class WebNotifier {
    constructor() {
        this.supported = typeof Notification !== 'undefined';
        this.hasPermission = this.supported && Notification.permission == 'granted';
        this.askedPermissionOnPlay = false;

        if (this.supported && !this.hasPermission) {
            this.requestPermission(() => {});
        }
    }

    notifyTrackPlaying(track) {
        if (!this.supported) { return; }

        if (!this.hasPermission) {
            if (!this.askedPermissionOnPlay) {
                this.askedPermissionOnPlay = true;

                this.requestPermission(() => {
                    if (this.hasPermission) {
                        this.notifyTrackPlaying(track);
                    }
                });
            }
            return;
        }

        var notify = new Notification(track.title, {
            body: 'Playing...',
            icon: track.album.artwork
        });
        setTimeout(() => notify.close(), 2000);
    }

    requestPermission(callback) {
        if (!this.supported) { return; }

        try {
            Notification.requestPermission()
            .then((permission) => {
                this.hasPermission = permission == 'granted';
                callback();
            });
        } catch (error) {
            // Safari doesn't return a promise for requestPermissions and it
            // throws a TypeError. It takes a callback as the first argument
            // instead.
            if (error instanceof TypeError) {
                Notification.requestPermission(() => {
                    this.hasPermission = true
                    callback();
                });
            } else {
                throw error;
            }
        }
    }
}


var notifier = new WebNotifier();
export default notifier;


window.WebNotifier = notifier;



// WEBPACK FOOTER //
// ./src/WebNotifier.js